module.exports = __webpack_public_path__ + "media/src/images/favicons/mstile-144x144-9cf125f7ff29f00f3b176450fa213b44.png";